import { createContext, use } from 'react';
import { type AccountState } from '@packages/auth';

export type { AccountState };

export const AccountContext = createContext<AccountState | null>(null);

export function useAccount(): AccountState {
  const context = use(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used within an AccountProvider');
  }
  return context;
}
